__turbopack_context__.v({
  "caption": "RadioButton-module-scss-module__37GMca__caption",
  "control": "RadioButton-module-scss-module__37GMca__control",
  "disabled": "RadioButton-module-scss-module__37GMca__disabled",
  "dot": "RadioButton-module-scss-module__37GMca__dot",
  "input": "RadioButton-module-scss-module__37GMca__input",
  "label": "RadioButton-module-scss-module__37GMca__label",
  "labelBlock": "RadioButton-module-scss-module__37GMca__labelBlock",
  "ring": "RadioButton-module-scss-module__37GMca__ring",
  "size_lg": "RadioButton-module-scss-module__37GMca__size_lg",
  "size_md": "RadioButton-module-scss-module__37GMca__size_md",
  "with_caption": "RadioButton-module-scss-module__37GMca__with_caption",
  "wrapper": "RadioButton-module-scss-module__37GMca__wrapper",
  "wrapper_embedded": "RadioButton-module-scss-module__37GMca__wrapper_embedded",
});
